export default __webpack_public_path__ + "static/media/nature_black_female.ff108729.png";